import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const invite = (newUser) => axios.post("api/v1/auth/signup/user", newUser);

const getUsers = (query) => axios.get(toQueryString("api/v1/users?", query));

const resendInvite = (userId) => axios.post(`/api/v1/users/${userId}/invite`);

const deleteUser = (id, newContentAuthor) =>
  axios.post(`/api/v1/users/${id}/delete`, { userId: newContentAuthor });

const removeBulk = (ids) =>
  axios.delete("api/v1/users/bulk", { data: { ids } });

// Per project: whether it has sites switched on, and all its sites.
const getProjectSites = (projectIds) =>
  axios.get(toQueryString("api/v1/users/project-sites?", { projectIds }));

const ApiUsersManagement = {
  invite,
  getUsers,
  resendInvite,
  deleteUser,
  removeBulk,
  getProjectSites,
};

export default ApiUsersManagement;
